module.exports = __webpack_public_path__ + "img/chevron-right.0da1fe53.svg";